import moment from "moment";

import { IJSidebarModel } from "../Models/UI/Sidebar/ISidebarModel";

class SidebarHelper {
    public static GetSidebarModel(): IJSidebarModel {
        return {
            IsOpen: false,
            IsCreateMode: false,
            SearchText: "",
            SearchIsInactiveSelected: false,
            SearchInPortalSelected: false,
            SearchInRelativesSelected: false,
            SearchMaxResults: 30,
            SelectedDate: new Date(),
            DateInputText: moment().format("YYYY-MM-DD"),
            SearchResultsPatients: [],
            SelectedPatientId: null,
            PatientCreationModel: null,
            IsAdvancedSearchView: false,
            GlobalSidebarIsOpenOnTabChange: false,
            CalendarSidebarIsOpenOnTabChange: true,
            UnsubmittedQuestionnairesCount: 0,
            PositiveQuestionnaireResultCount: 0
        };
    }
}

export { SidebarHelper };
